import React, { useEffect, useState } from 'react';
import { motion } from "framer-motion";
import {
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Box,
  Grid,
  Stack
} from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import configServ from "../../services/config";
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';

const validationSchema = yup.object({
  name: yup
    .string()
    .max(255, 'Name must be less than 255 characters')
    .required('Name is required'),
  isActive: yup.boolean(),
});

const DepartmentCard = ({
  fetchTableData, // Function to refresh the table data after creation
  isCreate,
  setIsCreate,
  isEdit,
  setIsEdit,
  editData,
  setEditData,
}) => {
  const [loading, setLoading] = useState(false);
  const {
    
     company_id,
   } = useSelector((state) => state.GlobalVariables);

 const formik = useFormik({
  initialValues: {
    name: '',
    isActive: true,
  },
  validationSchema,
  onSubmit: async (values, { resetForm }) => {
    try {
      setLoading(true);

      const payload = {
        name: values.name,
        status: values.isActive ? 'active' : 'inactive',
        company_id: company_id,
      };

      let response;

      if (isEdit) {
        response = await configServ.updateDepartment(editData.id, payload);
      } else {
        response = await configServ.storeDepartment(payload);
      }

      if (response?.status) {
        toast.success(
          isEdit
            ? "Department updated successfully!"
            : "Department created successfully!"
        );

        handleReset();
        setIsEdit(false);
        setEditData({});
        fetchTableData();
      } else {
        toast.error(response?.message || "Operation failed.");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong."
      );
    } finally {
      setLoading(false);
    }
  },
});

  useEffect(() => {
    if (isEdit && editData) {
      formik.setValues({
        name: editData.name || '',
        isActive: editData.status === 'active',
      });
    } else {
      formik.resetForm();
    }
  }, [isEdit, editData]);

  const handleReset = () => {
    formik.resetForm();
    setIsEdit(false);
    // setIsCreate(false);
    setEditData({});
  }

  return (
    <Box sx={{ maxWidth: "100%", margin: '20px auto', width: '95%' }}>
      <motion.div
        initial={{ opacity: 0, scale: 0.95, y: -20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        style={{
          backgroundColor: "#e3f3fc",
          padding: "25px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
        }}
      >
        <form onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                id="name"
                name="name"
                label="Department Name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name}
                sx={{ backgroundColor: '#fff', borderRadius: '4px' }}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    id="isActive"
                    name="isActive"
                    checked={formik.values.isActive}
                    onChange={formik.handleChange}
                  />
                }
                label={formik.values.isActive ? "Active" : "Inactive"}
              />
            </Grid>

            <Grid item xs={12}>
              <Stack direction="row" spacing={2} justifyContent="flex-end">
                <Button
                  variant="outlined"
                  color="inherit"
                  // type="reset"
                  onClick={handleReset}
                  disabled={loading}
                >
                  Reset
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save"}
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </form>
      </motion.div>
    </Box>
  );
};

export default DepartmentCard;